<div class="row">
  <div
    [ngClass]="{
      'col-md-6': selectedDateOption === FormlyDateRangeOptions.CUSTOM,
      'col-md-12': selectedDateOption !== FormlyDateRangeOptions.CUSTOM
    }"
  >
    <mat-form-field>
      <mat-label>{{ props.label }}</mat-label>
      <mat-select
        [(ngModel)]="selectedDateOption"
        (ngModelChange)="updateDateRange()"
      >
        @for (option of dateOptions; track option) {
          <mat-option [value]="option">
            {{ option }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  @if (selectedDateOption === FormlyDateRangeOptions.CUSTOM) {
    <div class="col-md-6">
      <mat-form-field>
        <mat-label>Custom</mat-label>
        <mat-date-range-input
          [id]="id"
          [formGroup]="formGroup"
          [required]="required"
          [formlyAttributes]="field"
          [tabIndex]="props.tabindex"
          [rangePicker]="rangePicker"
        >
          <input
            #rangeStart
            [readonly]="props.readonly"
            formControlName="start"
            matStartDate
            placeholder="Start date"
          />
          <input
            #rangeEnd
            [readonly]="props.readonly"
            formControlName="end"
            matEndDate
            placeholder="End date"
          />
          <!--    <input [readonly]="props.readonly" matStartDate placeholder="Start date" formControlName="start">-->
          <!--    <input [readonly]="props.readonly" matEndDate placeholder="End date" formControlName="end">-->
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="rangePicker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #rangePicker></mat-date-range-picker>
        <mat-error>
          <formly-validation-message
            [field]="field"
          ></formly-validation-message>
        </mat-error>
      </mat-form-field>
    </div>
  }
</div>
